import { CreateDomainFactors } from '../../pages/domain-factors/create/create-domain-factors.page';
import { DomainFactorsPage } from '../../pages/domain-factors/domain-factors.page';
import routes from '../routes/index.routes';
import { EditDomainFactors } from '../../pages/domain-factors/edit/edit-domain-factors.page';

export const DomainFactorsRouter = [
	{
		path: routes.domainFactors.index(),
		element: <DomainFactorsPage />,
		children: [
			{
				path: routes.domainFactors.create(),
				element: <CreateDomainFactors />,
			},
			{
				path: routes.domainFactors.edit(':domainFactorId'),
				element: <EditDomainFactors />,
			},
		],
	},
];
